export const styles = {
  container: { display: "flex", alignItems: "center" },
  formControlLabel: {
    visibility: "hidden",
    margin: 0,
  },
}
